// extracted by mini-css-extract-plugin
export var btn = "CourseList-module--btn--aLxLU";
export var container = "CourseList-module--container--hOM+C";
export var flex_item = "CourseList-module--flex_item--Ggs8M";
export var image = "CourseList-module--image--mLneP";
export var text = "CourseList-module--text--Xlkrm";
export var title = "CourseList-module--title--CoO0P";
export var vsBG = "CourseList-module--vsBG--r+0k5";
export var wrapper = "CourseList-module--wrapper--0e2gy";